module.exports = __webpack_public_path__ + "static/media/feed.09fd7705.svg";